import { PropsWithChildren } from "react";

export const BottomNavigationBar = ({ children }: PropsWithChildren) => {
  return (
    <div className="absolute inset-x-0 bottom-0 z-40 flex sm:hidden justify-center px-4 pt-2 pb-[max(0.875rem,env(safe-area-inset-bottom))] pointer-events-none">
      <nav className="flex items-center gap-1 max-w-full rounded-full bg-accent-500 p-2 shadow-[0_0.5rem_1.5rem_rgba(0,0,0,0.18)] pointer-events-auto">
        {children}
      </nav>
    </div>
  );
};
